import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { CREATE_DISCIPLINARY_RECORD, CREATING_DISCIPLINARY_RECORD, GETTING_DISCIPLINARY_RECORDS, GET_DISCIPLINARY_RECORDS, SET_SUCCESS, DISCIPLINARY_RECORDS_ERROR, UPDATING_DISCIPLINARY_RECORD, UPDATE_DISCIPLINARY_RECORD } from "../types"

export const fetchDisciplinaryRecords = (studentId, filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/disciplinary-records/student/${studentId}?expand=students,createdBy`

        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_DISCIPLINARY_RECORDS,
            payload: true
        })

        const response = await axios.get(url, { headers })

        dispatch({
            type: GET_DISCIPLINARY_RECORDS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: DISCIPLINARY_RECORDS_ERROR,
            error
        })
    }
}

export const createDisciplinaryRecord = (payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_DISCIPLINARY_RECORD,
            payload: true
        })
        
        const response = await axios.post(`${baseUrl}/disciplinary-records`, payload, { headers })
        
        dispatch({
            type: CREATE_DISCIPLINARY_RECORD,
            payload: response.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: 'New disciplinary record created successfully!'
        })
    }
    catch(error){
        dispatch({
            type: DISCIPLINARY_RECORDS_ERROR,
            error
        })
    }
}

export const clearCreatedDisciplinaryRecord = () => async (dispatch) => {    
    dispatch({
        type: CREATE_DISCIPLINARY_RECORD,
        payload: null
    })
}

export const updateDisciplinaryRecord = (id, payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_DISCIPLINARY_RECORD,
            payload: true
        })
        
        const response = await axios.patch(`${baseUrl}/disciplinary-records/${id}`, payload, { headers })
        
        dispatch({
            type: UPDATE_DISCIPLINARY_RECORD,
            payload: response.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: 'Student disciplinary record updated successfully!'
        })
    }
    catch(error){
        dispatch({
            type: DISCIPLINARY_RECORDS_ERROR,
            error
        })
    }
}

export const clearUpdatedDisciplinaryRecord = () => async (dispatch) => {    
    dispatch({
        type: UPDATE_DISCIPLINARY_RECORD,
        payload: null
    })
}